























































































































































































































import { defineComponent, ref } from '@vue/composition-api'
import { IAvmQuestion, IOrderData } from '@/api/types'
import { avmUpdate } from '@/api/orders'
import { OrdersModule } from '@/store/modules/orders'
import AvmUpload from './AvmUpload.vue'
import { notifyMessage } from '@/utils/error-display'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { uppercase, currency0, parseUtc, fixed2 } from '@/filters'

export default defineComponent({
  name: 'AvmDetail',
  components: {
    AvmUpload
  },
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit, attrs }) {
    const modelValue = ref<IOrderData>((attrs['v-model'] as IOrderData))
    const list = ref<Array<IAvmQuestion>>(null)
    const hasChanges = ref(false)
    const submitting = ref(false)
    const submittingDisabled = ref(false)
    const isEditMode = ref(false)

    const showAvmSummary = (): boolean => {
      if (modelValue.value === undefined) return false
      if (modelValue.value?.avmData === undefined) return false
      return modelValue.value?.avmData !== null
    }

    const showAvmUpload = (): boolean => {
      if (showAvmSummary()) return false
      return modelValue.value?.product?.avmReportAddOn === 'ManualUpload'
    }

    const showAvmDetail = (): boolean => {
      return showAvmSummary() || showAvmUpload()
    }

    const showSubmitButton = (): boolean => { return showAvmSummary() && !modelValue.value?.avmData?.summaryProvidedBy }

    const getNumber = (row: IAvmQuestion) => { return (row.question !== '') ? row.questionNumber : '  ' }

    const handleChange = () => {
      hasChanges.value = true
      submittingDisabled.value = !submitting.value
    }

    const getBorrowerNames = () => {
      return modelValue.value?.borrowerName2 !== null && modelValue.value?.borrowerName2 !== ''
        ? `${modelValue.value?.borrowerName}, ${modelValue.value?.borrowerName2}`
        : `${modelValue.value?.borrowerName}`
    }

    const created = (vm: IOrderData) => {
      if (props.isEdit) {
        // console.log(' edit AVM Summary created in edit mode ')
      }
      if (vm?.avmData?.avmQuestions !== undefined) {
        let counter = 0
        list.value = []
        for (const v of vm?.avmData?.avmQuestions) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          counter += 1
          list.value.push(v)
        }
      }
    }

    const toggleEditMode = () => {
      if (isEditMode.value) {
        handleChange()
        saveChanges()
      }
      isEditMode.value = !isEditMode.value
    }

    const saveChanges = async() => {
      if (hasChanges.value) {
        submittingDisabled.value = true
        await submitAvmData()
        submittingDisabled.value = false
      }
      hasChanges.value = false
    }

    const submitAvmData = async() => {
      const updatedOrder = await avmUpdate(modelValue.value.orderId, modelValue.value)
      if (updatedOrder) {
        // modelValue.avmData = updatedOrder.avmData
        emit('', modelValue.value)
        OrdersModule.updateOrder(modelValue.value)
        notifyMessage({
          title: 'Success',
          message: `AVM Summary ${modelValue.value.orderId} saved successfully.`,
          type: 'success',
          duration: 2000
        })
        setTimeout(() => {
          // eslint-disable-next-line no-self-assign
          window.location.href = window.location.href
        }, 3000)
        return true
      }
    }

    const triggerViewReport = () => {
      emit('viewReport')
    }

    created(modelValue.value)

    return {
      modelValue,
      list,
      hasChanges,
      submitting,

      showAvmDetail,
      showAvmSummary,
      showAvmUpload,
      showSubmitButton,

      getBorrowerNames,
      getNumber,
      saveChanges,
      handleChange,
      triggerViewReport,

      toggleEditMode,
      isEditMode
    }
  }
})
